// extracted by mini-css-extract-plugin
export default {"_dm-icon--publicly-available":"PubliclyAvailableIndicator__dm-icon--publicly-available__C0hFK","aria":"PubliclyAvailableIndicator_aria__JjyQc"};